import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge text-uppercase", _ctx.getDoubleSaleStatus(_ctx.status)])
  }, _toDisplayString(_ctx.statusLabel), 3))
}